import * as yup from 'yup';

export const clientStatusSchema = yup.object().shape({
    status: yup.string()
        .required('Please select a status')
        .nullable()
        .transform((curr, orig) => orig === '' ? null : curr),
    date: yup.string()
        .required('Please select a date')
        .nullable()
        .transform((curr, orig) => orig === '' ? null : curr),
    description: yup.string()
        .nullable()
        .transform((curr, orig) => orig === '' ? null : curr)
        .max(1000, 'Max character limit of 1000 reached')
});